module.exports = __webpack_public_path__ + "assets/1131748a49390c050947f7042d2cdf4a.ttf";